import axios from 'axios';
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { Sha256 } from "@aws-crypto/sha256-js";
import AWS from 'aws-sdk';

class ApiService {
  constructor() {
    //If we are in development mode and the testing locally with the endpoints
    this.apiEndpoint =
      process.env.NODE_ENV === "development" &&
      process.env.REACT_APP_LOCAL === "true"
        ? "http://localhost:8000/staging"
        : process.env.REACT_APP_API_GATEWAY_ENDPOINT; // Replace with your API Gateway endpoint
    this.region = process.env.REACT_APP_AWS_REGION; // Replace with your AWS region

    // Initialize AWS with the provided credentials
    AWS.config.update({
      region: process.env.REACT_APP_AWS_REGION,
      accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    });
  }

  generateSignedHeaders = async (method, path, data = null) => {
    const credentials = new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    });
  
    const urlObj = new URL(this.apiEndpoint);
    
    const headers = {
      Host: urlObj.host,
      "X-Amz-Date": new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z",
      "Content-Type": "application/json",
    };
  
    let body = "";
    if (data) {
      body = JSON.stringify(data);
    }
    headers["Content-Length"] = new TextEncoder().encode(body).length;

    // Ensure all header values are strings
    Object.keys(headers).forEach((key) => {
      headers[key] = String(headers[key]); // Ensures header values are strings
    });
  
    const request = {
      method,
      hostname: urlObj.host,
      path,
      headers,
      body,
    };
  
    const signer = new SignatureV4({
      credentials,
      region: this.region,
      service: "execute-api",
      sha256: Sha256,
    });
  
    const signedRequest = await signer.sign(request);
  
    return signedRequest.headers;
  };
  

  async makeRequest(method, path, data = null) {
    const headers = await this.generateSignedHeaders(method, path, data);
    const url = `${this.apiEndpoint}${path}`;
    try {
      delete headers.Host; // Host is not needed in the headers object
      delete headers["Content-Length"]; // Content-Length is not needed in the headers object
      const response = await axios({
        method,
        url,
        headers,
        data,
      });
      return response.data;
    } catch (error) {
      console.error(`Error making ${method} request to ${url}:`, error);
      throw error;
    }
  }

  async get(path) {
    return this.makeRequest("GET", path);
  }

  async post(path, data) {
    return this.makeRequest("POST", path, data);
  }

  async patch(path, data) {
    return this.makeRequest("PATCH", path, data);
  }

  async delete(path) {
    return this.makeRequest("DELETE", path);
  }

  render() {
    return null; // This component does not render anything
  }
}

export default ApiService;